import { useState, useEffect } from "react";

/**
 * useState that survives navigating away and coming back (back/forward button) within the same
 * browser tab. Backed by sessionStorage; falls back to plain state if storage is unavailable.
 */
const usePersistentState = (key, initialValue) => {
  const [value, setValue] = useState(() => {
    try {
      const raw = window.sessionStorage.getItem(key);
      return raw !== null ? JSON.parse(raw) : initialValue;
    } catch {
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch {
      /* storage unavailable (private mode / quota) - state still works in memory */
    }
  }, [key, value]);

  return [value, setValue];
};

export default usePersistentState;
